import { useAuthContext } from '@/modules/Auth/contexts/AuthContext'
import { useCancelationReasons } from '@/queries/cancelationReasons'
import { useCancelationReasonStore } from '@/stores/CancelationReasonStore'
import { useEffect } from 'react'

const useCancelationReasonsActions = () => {
  const { user } = useAuthContext()
  const cancelationReasons = useCancelationReasonStore(
    store => store.cancelationReasons,
  )
  const setCancelationReasons = useCancelationReasonStore(
    store => store.setCancelationReasons,
  )
  const { data: cancelationReasonsData } = useCancelationReasons(
    !!user && !cancelationReasons?.length,
  )

  useEffect(() => {
    if (!user || !cancelationReasonsData || cancelationReasons) return

    setCancelationReasons(cancelationReasonsData)
  }, [cancelationReasons, cancelationReasonsData, setCancelationReasons, user])
}

export { useCancelationReasonsActions }
